export const formatPhoneNumber = (phone: string): string => {
  if (/^\d{10}$/.test(phone)) {
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
  }
  return phone;
};

export interface ParentalConsentFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  parentalConsent: boolean;
  terms: boolean;
  consent: boolean;
}

export interface ParentalConsentPayload extends ParentalConsentFormData {
  fullname: string;
  birthdate: string;
}

export const buildParentalConsentPayload = (
  formData: ParentalConsentFormData,
  birthdate: string
): ParentalConsentPayload => {
  return {
    ...formData,
    fullname: `${formData.firstName} ${formData.lastName}`,
    birthdate,
  };
};
